module.exports = __webpack_public_path__ + "img/_a_.1b73d6cb.svg";